module.exports = require("next/error");


//////////////////
// WEBPACK FOOTER
// external "next/error"
// module id = next/error
// module chunks = 1